import { MessageCircle } from "lucide-react";
import { openSalesIQChat } from "./salesIQUtils";

export default function ExploreChatButton() {
  return (
    <button
      type="button"
      onClick={openSalesIQChat}
      aria-label="Open live chat"
      className="group fixed bottom-6 right-6 z-[9990] inline-flex items-center gap-2.5 rounded-full bg-ink px-4 py-3 text-white font-figtree font-semibold text-[0.92rem] shadow-[0_8px_28px_rgba(7,17,31,0.45)] transition-all hover:bg-ink2 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(7,17,31,0.55)] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50 focus-visible:ring-offset-2"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors group-hover:bg-white/15">
        <MessageCircle size={20} strokeWidth={2.25} aria-hidden />
      </span>
      <span className="hidden sm:inline pr-1">Chat with us</span>
    </button>
  );
}
